import { GetListResponse, instance } from "libs/api";

import { ApiRoutesTransfers } from "../../constants";
import { GetTransfersParams, Transfer } from "../../transfers.types";

export const requestGetTransfersList = async (
  params: GetTransfersParams,
): Promise<GetListResponse<Transfer>> => {
  return await instance.get(ApiRoutesTransfers.Transfers, { params });
};
